module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8017.7a792a9b.png";